export const lightColors = {
  primary: '#147b72',
  background: '#ffffff',
  input: '#f9fafb',
  error: '#ff5c5c',
  text: '#717784',
  heading: '#101623',
  secondaryButton: '#e8f3f1',
  primaryButton: '#199a8e',
  border: '#d1d5db',
  success: '#10b981',
} as const;

export const darkColors = {
  primary: '#20c9b8',
  background: '#0f1419',
  input: '#1a2332',
  error: '#ff7a7a',
  text: '#e2e8f0',
  heading: '#ffffff',
  secondaryButton: '#4a5568',
  primaryButton: '#20c9b8',
  border: '#4a5568',
  success: '#10b981',
} as const;

export const colors = lightColors;

export const getColor = (colorName: string) => {
  const color = colors[colorName as keyof typeof colors];
  if (color === undefined) {
    console.warn(`Color "${colorName}" not found`);
    return '#000000';
  }
  return color;
};

export const getColorCombinations = (mode: 'light' | 'dark') => {
  const currentColors = mode === 'dark' ? darkColors : lightColors;
  return {
    primary: {
      background: currentColors.background,
      text: currentColors.text,
      accent: currentColors.primary,
    },
    secondary: {
      background: currentColors.secondaryButton,
      text: currentColors.text,
      accent: currentColors.primaryButton,
    },
    card: {
      background: currentColors.background,
      text: currentColors.heading,
      border: currentColors.input,
    },
  };
};

export const colorCombinations = getColorCombinations('light');

export default colors;
